
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/pricing",
      function () {
        return require("private-next-pages/[lang]/pricing/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/pricing"])
      });
    }
  